import { useLanguageContext } from '../contexts/LanguageContext.js';

const useLanguage = (consumer) => useLanguageContext(consumer);

export { useLanguage };
//# sourceMappingURL=useLanguage.js.map
